import { Skeleton } from 'antd';

export function BookingCardSkeleton() {
  return (
    <div
      style={{
        margin: '0 16px 10px',
        borderRadius: 'var(--bl-radius-lg)',
        background: 'var(--bl-surface)',
        boxShadow: 'var(--bl-shadow)',
        border: '1px solid var(--bl-divider)',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'row',
      }}
    >
      {/* Left accent bar */}
      <div style={{ width: 4, background: 'var(--bl-divider)', flexShrink: 0 }} />

      {/* Content */}
      <div style={{ flex: 1, padding: '13px 14px', display: 'flex', flexDirection: 'column', gap: 8 }}>
        {/* Service + status */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
          <Skeleton.Input active size="small" style={{ width: 130, height: 16 }} />
          <Skeleton.Input active size="small" style={{ width: 80, height: 22, borderRadius: 20 }} />
        </div>
        {/* Provider */}
        <Skeleton.Input active size="small" style={{ width: 110, height: 13 }} />
        {/* Date/time block */}
        <Skeleton.Input active size="small" style={{ width: '100%', height: 34, borderRadius: 10 }} />
      </div>
    </div>
  );
}

export default function BookingCardSkeletonList() {
  return (
    <div style={{ paddingTop: 10 }}>
      <BookingCardSkeleton />
      <BookingCardSkeleton />
      <BookingCardSkeleton />
    </div>
  );
}
